import Ocr from '@/api/ocr.api.js'

/*eslint-disable */
export const runOcr = ({ commit }, data) => {
  return Ocr.runOcr(data)
    .then(response => {
      return response.data;
    })
}

export const runTemplate = ({ commit }, data) => {
  return Ocr.runTemplate(data)
    .then(response => {
      return response;
    })
}

export const getTemplateStatus = ({ commit }, data) => {
  return Ocr.getTemplateStatus(data)
    .then(response => {
      return response.data;
    })
}
/*eslint-enable */
